import ViewProgramAssistant from './ViewProgramAssistant';

export default ViewProgramAssistant;
